const pre = '/bcos/';

export default {
    path: '/bcos/privateKey',
    title: '私钥管理',
    header: '',
    icon: 'md-key',
}